const Compare = (() => {
  const STORAGE_KEY = 'compareIds';
  const MAX = 3;
  let controller = null;

  const getIds = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  const setIds = ids => localStorage.setItem(STORAGE_KEY, JSON.stringify(ids));

  async function render(ids) {
    const bar = document.getElementById('compare-sticky-bar');
    if (!bar) return;

    if (!ids.length) {
      bar.innerHTML = '';
      bar.style.display = 'none';
      return;
    }

    bar.style.display = '';
    controller?.abort();
    controller = new AbortController();

    try {
      const query = ids.map(id => `id:${id}`).join(' OR ');
      const res = await fetch(
        `/search?section_id=compare-sticky-bar&type=product&q=${encodeURIComponent(query)}`,
        { signal: controller.signal }
      );
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      bar.innerHTML = doc.getElementById('compare-sticky-bar')?.innerHTML ?? '';
    } catch (err) {
      if (err.name !== 'AbortError') console.warn('[Compare] Fetch failed:', err);
    }
  }

  async function renderCount(ids) {
    const countBar = document.querySelector('.filter_cta__btns');
    if (!countBar) return;

    if (!ids.length) {
      const a = countBar.querySelector('a');
      if (a) a.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0895/0287/6019/files/weight.svg?v=1780602206" height="auto" width="auto">COMPARE PRODUCTS';
      return;
    }

    const query = ids.map(id => `id:${id}`).join(' OR ');
    const res = await fetch(
      `/search?section_id=main-collection&type=product&q=${encodeURIComponent(query)}`
    );
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const btn = doc.querySelector('.filter_cta__btns a');
    if (btn) countBar.querySelector('a').innerHTML = btn.innerHTML;
  }

  function init() {
    const ids = getIds();
    const bar = document.getElementById('compare-sticky-bar');
    const isSearchPage = window.location.pathname === '/search';

    if (bar && !ids.length) bar.style.display = 'none';

    if (!isSearchPage) {
      ids.forEach(id => {
        const cb = document.querySelector(`.compare-checkbox[value="${id}"]`);
        if (cb) cb.checked = true;
      });
    }

    if (ids.length) {
      render(ids);
      renderCount(ids);
    }
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.close_compare__sec')) return;
      if (window.innerWidth < 768) return;
      document.getElementById('compare-sticky-bar')?.classList.add('compare-close');
    });
   document.addEventListener('click', function(e) {
    if (!e.target.closest('.filter_cta__btns a')) return;
    const ids = getIds();
    if (!ids.length) return;
    const bar = document.getElementById('compare-sticky-bar');
    if (!bar) return;
    bar.classList.remove('compare-close');
  });
    document.addEventListener('filter:update', function() {
      const ids = getIds();
      queueMicrotask(() => renderCount(ids));
    });
  }

  function onChange(e) {
    if (!e.target.classList.contains('compare-checkbox')) return;

    const checked = [...document.querySelectorAll('.compare-checkbox:checked')].map(c => c.value);

    if (checked.length > MAX) {
      e.target.checked = false;
      return;
    }

    document.getElementById('compare-sticky-bar')?.classList.remove('compare-close');

    setIds(checked);
    render(checked);
    renderCount(checked);
  }

  return { init, onChange };
})();

document.addEventListener('DOMContentLoaded', Compare.init);
document.addEventListener('change', Compare.onChange);